/**
 * @generated SignedSource<<0b70869b10488fc9557c30eeb9965bb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PricingFrequency = "annually" | "monthly" | "weekly" | "%future added value";
export type PricingKind = "free" | "one_time" | "recurring" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MembershipPlanDetailsCardFragment$data = {
  readonly cover: string;
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly pricing: {
    readonly amountCents: number;
    readonly frequency: PricingFrequency | null;
    readonly kind: PricingKind;
    readonly " $fragmentSpreads": FragmentRefs<"pricingUtils_usePricingDisplayValue">;
  } | null;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBadgeStackFragment_membership">;
  readonly " $fragmentType": "MembershipPlanDetailsCardFragment";
};
export type MembershipPlanDetailsCardFragment$key = {
  readonly " $data"?: MembershipPlanDetailsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanDetailsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hideDrafts"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hideNonPublic"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembershipPlanDetailsCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hideDrafts",
          "variableName": "hideDrafts"
        },
        {
          "kind": "Variable",
          "name": "hideNonPublic",
          "variableName": "hideNonPublic"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductBadgeStackFragment_membership"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Pricing",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountCents",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frequency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "pricingUtils_usePricingDisplayValue"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "b676d43b5842de15e88ecb150efd9d3e";

export default node;
